import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import '../static/font/iconfont.css'
import './assets/style/index.css'
import './permission' // permission control
import 'element-ui/lib/theme-chalk/index.css'
// import 'viewerjs/dist/viewer.css'
import "./assets/styles/element-variables.scss";
import "./assets/styles/dialog.scss";
import "./assets/styles/antd.css";
import "./assets/icons"; // icon
import globalVariable from "./utils/globalVariable"; // 公共解析公式
import $toast from "@/components/Toast/index.js";
import plugins from "./plugins"; // plugins
import VueViewer from 'v-viewer'
import store from '@/store/index'
import Input from "@/components/Input/index";
import Select from "@/components/Select/index";
import Join from "@/components/Join/index";
import NoClass from "@/components/NoClass/NoClass";
import AuditDetail from "@/components/AuditDetail/AuditDetail";
import NoData from "@/components/NoDatas/index";
import Pagination from "@/components/pagination/index";
import Cookies from "js-cookie";
import { resetForm } from "@/utils/ruoyi";
import dialogDrag from "@/directives/dialogDrag";
import listLoading from "@/directives/listLoading";
// 图片预览组件
import hevueImgPreview from "hevue-img-preview";
import aiDrag from "@/directives/aiDrag";
import { openExternal } from "./utils/index";
import AesEncrypt from "@/utils/aesEncrypt";
import VueKatex from 'vue-katex'
import 'katex/dist/katex.min.css'
import customDrag from "@/directives/customDrag";
Vue.prototype.openExternal = openExternal;
Vue.config.productionTip = false
Vue.prototype.resetForm = resetForm;
Vue.prototype.commonsVariable = globalVariable;
Vue.prototype.$aesEncrypt = AesEncrypt;
ElementUI.Dialog.props.lockScroll.default = false
Vue.use(VueViewer)
Vue.use(dialogDrag);
Vue.use(listLoading);
Vue.use(aiDrag);
Vue.use($toast);
Vue.use(plugins);
Vue.use(customDrag);
// import {
//   Tooltip,
//   Input,
//   Upload,
//   Dialog,
//   Checkbox,
//   CheckboxGroup,
//   Pagination,
//   Select,
//   Option,
//   Loading,
//   Slider,
//   Popover,
//   InputNumber,
//   Button,
//   Col
// } from "element-ui";

// Vue.use(Tooltip);
// Vue.use(Input);
// Vue.use(Upload);
// Vue.use(Dialog);
// Vue.use(Checkbox);
// Vue.use(CheckboxGroup)
// Vue.use(Pagination);
// Vue.use(Select);
// Vue.use(Option);
// Vue.use(Loading);
// Vue.use(Slider);
// Vue.use(Popover);
// Vue.use(InputNumber);
// Vue.use(Button);
// Vue.use(Col);
Vue.use(ElementUI, {
  size: Cookies.get("size") || "medium", // set element-ui default size
});
Vue.component("Input", Input);
Vue.component("Select", Select);
Vue.component("Pagination", Pagination);
Vue.component("Join", Join);
Vue.component("NoClass", NoClass);
Vue.component("NoData", NoData);
Vue.component("AuditDetail", AuditDetail);
Vue.use(hevueImgPreview);
Vue.use(VueKatex, {
  globalOptions: {
    delimiters: [
      { left: "$$", right: "$$", display: true },
      { left: "$", right: "$", display: false },
      { left: "\\(", right: "\\)", display: false },
      { left: "\\[", right: "\\]", display: true }
    ],
    throwOnError: false
  }
})

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
if (process.env.VUE_APP_BASE_API.indexOf('book.coursegate.cn') > -1) {
  // 引入百度统计代码
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?2a52ea916dc05e02b902af0769708971";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
}
